// EmailContainer.js
import React from 'react';
import { Box, Typography, Grid } from '@mui/material';
import IntegrationItem from './IntegrationItem';
import { INTEGRATIONS_CONFIG } from 'config/integrationsConfig';
import { getIconComponent } from '../../utils/icons/iconUtils';

const EmailContainer = ({ searchTerm = '' }) => {
    const filteredIntegrations = INTEGRATIONS_CONFIG.EMAIL.filter(integration =>
        integration.name.toLowerCase().includes(searchTerm.toLowerCase())
    );

    if (filteredIntegrations.length === 0 && searchTerm) {
        return null;
    }

    return (
        <Box>
            <Typography
                variant="h5"
                sx={{
                    fontWeight: 600,
                    mb: 3,
                    color: '#242020'
                }}
            >
                Email
            </Typography>
            <Typography
                variant="body1"
                sx={{
                    mb: 3,
                    color: '#828282'
                }}
            >
                Sync Touch leads and email signatures to your email client
            </Typography>
            <Grid container spacing={2}>
                {filteredIntegrations.map((integration) => (
                    <Grid item xs={12} sm={6} md={3} key={integration.name}>
                        <IntegrationItem
                            text={integration.name}
                            icon={getIconComponent(integration.name)}
                            disabled={integration.disabled}
                            comingSoon={integration.comingSoon}
                        />
                    </Grid>
                ))}
            </Grid>
        </Box>
    );
};

export default EmailContainer;